/* ADD SOFTSKILL ABILITY */
export const ADD_SOFTSKILL_ABILITY_USER = "ADD_SOFTSKILL_ABILITY_USER"
export const ADD_SOFTSKILL_ABILITY_USER_SUCCESS =
  "ADD_SOFTSKILL_ABILITY_USER_SUCCESS"
export const ADD_SOFTSKILL_ABILITY_USER_CLEAN =
  "ADD_SOFTSKILL_ABILITY_USER_CLEAN"
export const ADD_SOFTSKILL_ABILITY_USER_ERROR =
  "ADD_SOFTSKILL_ABILITY_USER_ERROR"
